<div class="workSpace">
  <!--NOMBRE Y FILTROS-->
  <div class="headersTab">
    <!--Nombre módulo y submódulo-->
    <div class="w3-caja-menu padreizquierda w3-veinte">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ "menu." +
          dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ "menu." +
          dataService.subModuleSelect | translate }} </span>
      </div>
    </div>
    <!-- AÑOS -->
    <div class="w3-third">
      <app-filters
        [array]="aniosDisponibles"
        [typeFilter]="Filtros.YEAR"
        [name]="'filtros.anio' | translate"
        (eventClick)="anioChange($event)"
        [click]="false"
      >
      </app-filters>
    </div>
    <!-- MESES -->
    <div class="w3-third">
      <app-filters
        [array]="mesesDisponibles"
        [typeFilter]="Filtros.MOUNTH"
        [name]="'filtros.mes' | translate"
        (eventClick)="mesChange($event)"
        [click]="false"
      >
      </app-filters>
    </div>
  </div>

  <!--CONTENIDO-->
  <div class="w3-row workSpaceTab informeWrapper">
    

    <!--IZQUIERDA: selector de secciones del informe-->
    <div class="zonaSecciones w3-scroll">
      @for (sec of secciones; track sec.id) {
        <div class="grupoSeccion">
          <!--Sección principal o encabezado de grupo-->
          @if (sec.encabezado) {
            <div class="secHeader">{{ sec.nombre }}</div>
          } @else {
            <div class="togElement">
              <mat-slide-toggle labelPosition="before" [(ngModel)]="sec.activo" (change)="repintarIconos()">
                <span class="secLabel" [class.destacado]="sec.destacado">{{ sec.nombre }}</span>
              </mat-slide-toggle>
            </div>
          }

          <!--Subsecciones (sucursales / variables)-->
          @if (sec.hijos && (sec.encabezado || sec.activo)) {
            @for (hijo of sec.hijos; track hijo.id) {
              <div class="togElement togHijo">
                <mat-slide-toggle labelPosition="before" [(ngModel)]="hijo.activo" (change)="repintarIconos()">
                  <span class="secLabel">{{ hijo.nombre }}</span>
                </mat-slide-toggle>
              </div>
            }
          }
        </div>
      }
    </div>

    <!--DERECHA: vista previa del informe-->
    <div class="zonaPreview">
      <div class="informePreview w3-white w3-scroll">
        <div class="informeTitulo">Informe evaluación clima laboral</div>
        <div class="informeSubtitulo">Evaluación {{ mesSel }} {{ anioSel }}</div>

        <!--METODOLOGÍA-->
        @if (activa('metodologia')) {
          <section class="bloquePreview">
            <div class="pageName">{{ seccion('metodologia').nombre }}</div>
            <ng-container [ngTemplateOutlet]="textoTpl"
              [ngTemplateOutletContext]="{ $implicit: seccion('metodologia') }"></ng-container>
          </section>
        }

        <!--COMPOSICIÓN DE LA MUESTRA-->
        @if (activa('composicion')) {
          <section class="bloquePreview">
            <div class="pageName">{{ seccion('composicion').nombre }}</div>
            <div class="w3-scroll">
              <table class="w3-table">
                <thead>
                  <tr class="w3-table-titleLow w3-center">
                    <th class="w3-border-right-balance">Característica</th>
                    <th class="w3-border-right-balance">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  @for (fila of composicionTabla; track $index) {
                    <tr class="w3-table-trtd w3-center borderInfLow">
                      <td class="borderAllLow">{{ fila.caracteristica }}</td>
                      <td class="borderAllLow">{{ fila.valor }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <ng-container [ngTemplateOutlet]="textoTpl"
              [ngTemplateOutletContext]="{ $implicit: seccion('composicion') }"></ng-container>
          </section>
        }

        <!--EVALUACIÓN GLOBAL-->
        @if (activa('evaluacion-global')) {
          <section class="bloquePreview">
            <div class="pageName">{{ seccion('evaluacion-global').nombre }}</div>
            <div class="zonaGraf">
              <app-graficador
                [data]="globalData" [labels]="dimLabels" [type]="types.BAR"
                [colors]="colorScheme" [axisX]="'Dimensión'" [axisY]="['Calificación']"
                [zona]="1" [etiquetas]="false" [legend]="legendGraf" />
            </div>
            <ng-container [ngTemplateOutlet]="textoTpl"
              [ngTemplateOutletContext]="{ $implicit: seccion('evaluacion-global') }"></ng-container>
          </section>
        }

        <!--CONSOLIDADO-->
        @if (activa('consolidado')) {
          <section class="bloquePreview">
            <div class="pageName">{{ seccion('consolidado').nombre }}</div>
            <div class="zonaGraf">
              <app-graficador
                [data]="globalData" [labels]="dimLabels" [type]="types.LINE"
                [colors]="colorScheme" [axisX]="'Dimensión'" [axisY]="['Calificación']"
                [zona]="3" [etiquetas]="false" [legend]="legendGraf" />
            </div>
            <ng-container [ngTemplateOutlet]="textoTpl"
              [ngTemplateOutletContext]="{ $implicit: seccion('consolidado') }"></ng-container>
            <!--Subsecciones: sucursales activas-->
            @for (hijo of seccion('consolidado').hijos; track hijo.id) {
              @if (hijo.activo) {
                <div class="subBloque">
                  <div class="subBloqueTitulo">{{ hijo.nombre }}</div>
                  <ng-container [ngTemplateOutlet]="textoTpl"
                    [ngTemplateOutletContext]="{ $implicit: hijo }"></ng-container>
                </div>
              }
            }
          </section>
        }

        <!--EVALUACIÓN DIMENSIONES-->
        @if (activa('dimensiones')) {
          <section class="bloquePreview">
            <div class="pageName">{{ seccion('dimensiones').nombre }}</div>
            <div class="zonaGraf">
              <app-graficador
                [data]="dimensionesData" [labels]="dimLabels" [type]="types.RADAR"
                [colors]="colorScheme" [axisX]="'Dimensión'" [axisY]="['Calificación']"
                [zona]="2" [etiquetas]="false" [legend]="legendGraf" />
            </div>
            <ng-container [ngTemplateOutlet]="textoTpl"
              [ngTemplateOutletContext]="{ $implicit: seccion('dimensiones') }"></ng-container>
          </section>
        }

        <!--ANÁLISIS COMBINADO (encabezado: visible si hay variables activas)-->
        @if (tieneHijosActivos(seccion('analisis-combinado'))) {
          <section class="bloquePreview">
            <div class="pageName">{{ seccion('analisis-combinado').nombre }}</div>
            @for (hijo of seccion('analisis-combinado').hijos; track hijo.id; let i = $index) {
              @if (hijo.activo) {
                <div class="subBloque">
                  <div class="subBloqueTitulo">{{ hijo.nombre }}</div>
                  <div class="zonaGraf">
                    <app-graficador
                      [data]="globalData" [labels]="dimLabels" [type]="types.LINE"
                      [colors]="colorScheme" [axisX]="'Dimensión'" [axisY]="['Calificación']"
                      [zona]="10 + i" [etiquetas]="false" [legend]="legendGraf" />
                  </div>
                  <ng-container [ngTemplateOutlet]="textoTpl"
                    [ngTemplateOutletContext]="{ $implicit: hijo }"></ng-container>
                </div>
              }
            }
          </section>
        }

        <!--CONCLUSIONES-->
        @if (activa('conclusiones')) {
          <section class="bloquePreview">
            <div class="pageName">{{ seccion('conclusiones').nombre }}</div>
            <ng-container [ngTemplateOutlet]="textoTpl"
              [ngTemplateOutletContext]="{ $implicit: seccion('conclusiones') }"></ng-container>
          </section>
        }
      </div>
    </div>
  </div>

  <!--Botón flotante de descarga (igual que en reporte)-->
  <div class="botonExportar">
    <button mat-fab class="fab textoOverFlow" (click)="generarPDF()" matTooltip="Descargar informe">
      <mat-icon>download</mat-icon>
    </button>
  </div>
</div>

<!--====================== TEMPLATES REUTILIZABLES ======================-->

<!--Análisis editable de cada sección (textarea)-->
<ng-template #textoTpl let-item>
  <mat-form-field appearance="outline" class="zonaTexto" color="warn">
    <mat-label>Análisis</mat-label>
    <textarea matInput rows="4" [(ngModel)]="item.texto"></textarea>
  </mat-form-field>
</ng-template>
